module.exports = __webpack_public_path__ + "img/epc1cores.1e879f38.png";